/* eslint-disable simple-import-sort/imports */
import { z } from 'zod';
import { API_PATH_PREFIX } from '../runtime/env';
const OauthAuthorizeResponseSchema = z.object({
    signInUrl: z.string().min(1),
});
const FinalizeResponseSchema = z.object({
    redirectUri: z.string().min(1),
});
const SessionEndResponseSchema = z.object({
    redirectUrl: z.string().min(1),
});
export class IdpProxyError extends Error {
    status;
    code;
    constructor(status, code, message) {
        super(message);
        this.status = status;
        this.code = code;
        this.name = 'IdpProxyError';
    }
}
async function postJson(url, body, schema) {
    const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });
    if (!response.ok) {
        let code = 'UNKNOWN_ERROR';
        let message = `HTTP ${response.status}`;
        try {
            const payload = (await response.json());
            code = payload.error?.code ?? code;
            message = payload.error?.message ?? message;
        }
        catch {
            // ignore JSON parse failure
        }
        throw new IdpProxyError(response.status, code, message);
    }
    const json = await response.json();
    const parsed = schema.safeParse(json);
    if (!parsed.success) {
        throw new IdpProxyError(200, 'INVALID_RESPONSE_SHAPE', `Unexpected response shape: ${parsed.error.message}`);
    }
    return parsed.data;
}
/**
 * Initiates an OIDC authorization flow by calling POST /api/v1/oauth/authorize on the IDP.
 * Returns the sign-in URL to navigate the browser to.
 */
export async function submitOauthAuthorize(params, options) {
    return postJson(`${options.idpApiBase}${API_PATH_PREFIX}/oauth/authorize`, params, OauthAuthorizeResponseSchema);
}
/**
 * Finalizes an OIDC interaction by calling POST /api/v1/interaction/{uid}/finalize on the IDP.
 * Returns the redirect URI to navigate the browser to.
 */
export async function finalizeInteraction(uid, options) {
    return postJson(`${options.idpApiBase}${API_PATH_PREFIX}/interaction/${encodeURIComponent(uid)}/finalize`, {}, FinalizeResponseSchema);
}
/**
 * Ends an IDP session by calling POST /api/v1/session/end on the IDP.
 * Returns the redirect URL to navigate the browser to.
 */
export async function submitSessionEnd(params, options) {
    return postJson(`${options.idpApiBase}${API_PATH_PREFIX}/session/end`, params, SessionEndResponseSchema);
}
